import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const PeerReview = ({ data = {} }) => {
  const { peer_review: remark, peer_review_date: dateOfRemark } = data;
  const TextWrapper = ({ children }) => (
    <Typography
      sx={{ fontSize: "1.2rem", fontWeight: 500, fontStyle: "Inter" }}
    >
      {children}
    </Typography>
  );
  return (
    <Box>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={2} sm={2} md={2}>
          <TextWrapper>Date of Remark</TextWrapper>
        </Grid>
        <Grid item xs={10} sm={10} md={10}>
          <TextWrapper> Remark</TextWrapper>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{ paddingTop: "0 !important", margin: 0 }}
        >
          <hr
            style={{
              marginTop: "12px",
              marginBottom: "8px",
              border: "1px solid #BFBFBF",
            }}
          ></hr>
        </Grid>
        {remark ? (
          <>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              sx={{ paddingTop: "0 !important", margin: 0 }}
            >
              <TextWrapper>
                {dateOfRemark?.replaceAll("-", "/") || "-"}
              </TextWrapper>
            </Grid>
            <Grid
              item
              xs={10}
              sm={10}
              md={10}
              sx={{ paddingTop: "0 !important", margin: 0 }}
            >
              <TextWrapper>{remark || "-"}</TextWrapper>
            </Grid>
          </>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{ paddingTop: "0 !important", margin: 0 }}
          >
            <TextWrapper>No Data</TextWrapper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PeerReview;
